import React from "react";
import { useTranslation } from "react-i18next";
import "../style/Footer.css";

const APK_DOWNLOAD_URL =
  "https://drive.google.com/uc?export=download&id=1YSYCJg6m0egz-cVXMrvpg-fAij9b4FuS";
const FACEBOOK_URL = "https://www.facebook.com/share/17mn5fDn9J/";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src="/images/ahmad hasoun 2 1.png" alt="Ghina Shop" />
          <p>{t("appPromo.subtitle")}</p>
        </div>

        <div className="footer-actions">
          <a
            className="promo-btn download-btn"
            href={APK_DOWNLOAD_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
              <path
                fill="currentColor"
                d="M12 16l-5-5h3V4h4v7h3l-5 5zm-7 2h14v2H5v-2z"
              />
            </svg>
            <span>{t("appPromo.download")}</span>
          </a>

          <a
            className="promo-btn facebook-btn"
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
              <path
                fill="currentColor"
                d="M22 12a10 10 0 10-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0022 12z"
              />
            </svg>
            <span>{t("appPromo.followFacebook")}</span>
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {year} Ghina Shop — {t("appPromo.title")}</p>
      </div>
    </footer>
  );
};

export default Footer;
